import { RefObject } from "react";
import { Row } from "react-table";
import { BaseCheckbox } from "src/components";

type Props<T extends object> = {
  /** react-table 현재 페이지 rows */
  rows: Row<T>[];
  getHeaderChecked: (rows: Row<T>[]) => boolean;
  onToggleAll: (rows: Row<T>[], checked: boolean) => void;
  inputRef?: RefObject<HTMLInputElement>;
  id?: string;
};

/** 테이블 헤더 전체선택 체크박스 (useSelectAllColumn 훅과 함께 사용) */
export function SelectAllHeaderCheckbox<T extends object>({ rows, getHeaderChecked, onToggleAll, inputRef, id = "selectAll" }: Props<T>) {
  return (
    <BaseCheckbox
      inputRef={inputRef}
      id={id}
      name={id}
      checked={getHeaderChecked(rows)}
      onChange={(checked: boolean) => onToggleAll(rows, checked)}
    />
  );
}
